import { render, staticRenderFns } from "./VerbalIdentityIntroSecition.vue?vue&type=template&id=9d2d812a"
import script from "./VerbalIdentityIntroSecition.vue?vue&type=script&lang=ts"
export * from "./VerbalIdentityIntroSecition.vue?vue&type=script&lang=ts"
import style0 from "./VerbalIdentityIntroSecition.vue?vue&type=style&index=0&id=9d2d812a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports